import React from "react";
import { Helmet } from "react-helmet";

interface Props {
  font: string;
}

interface FinalFontProps {
  value: string;
  href?: string;
}

const FontStyle = ({ font }: Props) => {
  const fontFamily = finalFont(font);
  let scriptFontFamily = <></>;

  if (fontFamily.href) {
    scriptFontFamily = (
      <script type="text/javascript">
        {`
                    WebFontConfig = {
                        google: {
                        families: [ "${fontFamily.href}" ]
                        }
                    };

                    (function() {
                        const wf = document.createElement('script');
                        wf.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
                        wf.type = 'text/javascript';
                        wf.async = 'true';
                        const s = document.getElementsByTagName('script')[0];
                        s.parentNode.insertBefore(wf, s);
                    })();
                `}
      </script>
    );
  }

  return (
    <Helmet>
      {scriptFontFamily}
      <style>{`
            body .planne-widget {
                font-family: ${fontFamily.value};
            }

            body {
                font-family: ${fontFamily.value};
            }

        `}</style>
    </Helmet>
  );
};

const finalFont = (font: string): FinalFontProps => {
  switch (font) {
    case "poppins":
      return {
        value: "Poppins, sans-serif",
        href: "Poppins:wght@300;400;600",
      };
    case "arial":
      return {
        value: "Arial, sans-serif",
      };
    case "dancing_script":
      return {
        value: "'Dancing Script', cursive",
        href: "Dancing+Script:wght@400;500;700",
      };
    case "ibm_plex_sans":
      return {
        value: "'IBM Plex Sans', sans-serif",
        href: "IBM+Plex+Sans:wght@300;400;600",
      };
    case "merriweather":
      return {
        value: "'Merriweather', serif",
        href: "Merriweather:wght@300;400;900",
      };
    case "merriweather_sans":
      return {
        value: "'Merriweather Sans', sans-serif",
        href: "Merriweather+Sans:wght@300;400;500",
      };
    case "montserrat":
      return {
        value: "'Montserrat', sans-serif",
        href: "Montserrat:wght@300;400;500",
      };
    case "nunito":
      return {
        value: "'Nunito', sans-serif",
        href: "Nunito:wght@300;400;500",
      };
    case "nunito_sans":
      return {
        value: "'Nunito Sans', sans-serif",
        href: "Nunito+Sans:wght@300;400;700",
      };
    case "open_sans":
      return {
        value: "'Open Sans', sans-serif",
      };
    case "roboto":
      return {
        value: "'Roboto', sans-serif",
        href: "Roboto:wght@300;400;500",
      };
    case "times_new_roman":
      return {
        value: "'Times New Roman', Times, serif",
      };
    case "libre_baskerville":
      return {
        value: "'Libre Baskerville', serif",
        href: "Libre+Baskerville:wght@400;700&display=swap",
      };
    case "arimo":
      return {
        value: "'Arimo', sans-serif",
        href: "Arimo:wght@400;500;600&display=swap",
      };
    case "kanit":
      return {
        value: "'Kanit', sans-serif",
        href: "Kanit:wght@300;400;500&display=swap",
      };
    case "prompt":
      return {
        value: "'Prompt', sans-serif",
        href: "Prompt:wght@300;400;500&display=swap",
      };
    case "questrial":
      return {
        value: "'Questrial', sans-serif",
        href: "Questrial&display=swap",
      };
    case "ubuntu":
      return {
        value: "'Ubuntu', sans-serif",
        href: "Ubuntu:wght@300;400;500&display=swap",
      };
    case "yanone":
      return {
        value: "'YANONE KAFFEESATZ', sans-serif",
        href: "Yanone+Kaffeesatz:wght@300;400;500;600;700&display=swap",
      };
    default:
      return {
        value: "sans-serif",
      };
  }
};

export default FontStyle;
